import type { MatSnackBarConfig } from '@angular/material/snack-bar';

export const DefaultNotyTimeout = 4000;
export const DefaultNotySettings: MatSnackBarConfig = {
  horizontalPosition: 'right',
  verticalPosition: 'bottom',
  // Use multiple classes for higher specificity and to prevent race conditions
  panelClass: ['custom-toastr', 'dn-noty-container'],
  duration: DefaultNotyTimeout,
};
